import styled from 'styled-components';

export const Form = styled.form`
	button {
		margin-top: 24px;
		width: 100%;
	}

`;
